import React, { useEffect, useState } from "react"
import { OverlayDrawer } from "packages/ui-shared/components/OverlayDrawer"
import { ProgressBarV2 } from "../ProgressBarV2/ProgressBarV2"
import { Header } from "./components/Header"
import {
  contentContainer,
  ctaWrapper,
  overlayWrapper,
  wrapper,
} from "./DiscoveryJourneyModal.css"
import { useDiscoveryJourney } from "./useDiscoveryJourney"
// eslint-disable-next-line import/no-unresolved -- clash with /slides directory
import { slides } from "./components/Slides"

type Props = {
  isVisible: boolean
  setNextVisibility: (visible: boolean) => void
}

export const DiscoveryJourneyModal: React.FC<Props> = ({
  isVisible,
  setNextVisibility,
}) => {
  const [currentSlideIndex, setCurrentSlideIndex] = useState(0)
  const { slides: journeySlides } = useDiscoveryJourney()
  const [slideId, setSlideId] = useState(journeySlides[0]?.id)

  const backToPreviousSlide = () => setCurrentSlideIndex(currentSlideIndex - 1)
  const goToNextSlide = () => setCurrentSlideIndex(currentSlideIndex + 1)

  useEffect(() => {
    setSlideId(journeySlides[currentSlideIndex]?.id)
  }, [currentSlideIndex, journeySlides])

  const content = slides({
    slides: journeySlides,
    currentSlideIndex,
    backToPreviousSlide,
    goToNextSlide,
    setNextVisibility,
  })

  if (Array.isArray(journeySlides) && journeySlides.length > 0) {
    return (
      <OverlayDrawer isOpen={isVisible} className={overlayWrapper}>
        <div className={wrapper}>
          <Header
            handleCloseModal={() => setNextVisibility(false)}
            slideId={slideId}
          />
          <ProgressBarV2
            currentStep={currentSlideIndex + 1}
            allSteps={journeySlides.length}
          />
          <div className={contentContainer}>{content.component}</div>
          <div>
            <div className={ctaWrapper}>{content.cta}</div>
          </div>
        </div>
      </OverlayDrawer>
    )
  }

  return null
}
